// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>8</span>&nbsp;&nbsp;But I am like a spreading olive tree in the house of God;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;I trust in the goodness of God for ever and ever.<br> </p> </div></div>";
// Exports
module.exports = code;